<template>
  <div>
    <PageTitle
      title="Purchase Order View"
      :backBtn="true"
      :editRoute="'/purchase-order/edit/' + PurchaseOrder.id"
      :permission="'Purchase Order Edit'"
      :printvisible="true"
      @openPrintmethod="GotoPrintDetails"
    />
    <v-container
      fluid
      class="lighten-12 container pa-3"
      style="background-color: white"
    >
      <!-- Page Title -->

      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12" class="py-1 px-5">
          <v-card class="lighten-12">
            <v-card-title class="v-card__title saletiltle"
              ><v-icon color="blue" small>mdi-sale</v-icon
              ><span class="ml-3"> Purchase Order Details</span></v-card-title
            >
            <v-container fluid class="container saledetailscard">
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                  <v-row class="pt-0 mb-5">
                    <v-col
                      cols="12"
                      sm="12"
                      md="6"
                      lg="6"
                      class="pr-5 pt-1.5 pb-1 reference_number"
                    >
                      <v-icon>mdi-sale</v-icon>
                      {{
                        PurchaseOrder.reference_number
                          ? PurchaseOrder.reference_number
                          : '----'
                      }}
                    </v-col>

                    <v-col cols="12" sm="12" md="4" lg="4"
                      ><span class="statustext pr-5">Status</span>
                      <v-chip
                        label
                        text-color="white"
                        :color="
                          getPurchaseOrderStatusColor(PurchaseOrder.status)
                        "
                        dark
                        class="orderData"
                        >{{
                          PurchaseOrder.status ? PurchaseOrder.status : '----'
                        }}
                      </v-chip>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="4"
                      lg="4"
                      class="textbold pr-5 pt-0"
                    >
                      <v-row class="subtextlable"> Date </v-row>
                      <v-row>
                        <v-icon small class="mr-1">mdi-calendar</v-icon>
                        {{ PurchaseOrder.date | formatDate }}
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="12" md="1" lg="1" class="textbold">
                      <v-divider></v-divider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="4"
                      lg="4"
                      class="textbold pr-5 pt-0"
                    >
                      <v-row class="subtextlable"> Supplier </v-row>
                      <v-row>
                        {{
                          PurchaseOrder.suppliers.name
                            ? PurchaseOrder.suppliers.name
                            : '----'
                        }}
                      </v-row>
                    </v-col>

                    <v-col cols="1" sm="12" md="1" lg="1" class="textbold">
                      <v-divider></v-divider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="2"
                      lg="2"
                      class="textbold pr-5 pt-0"
                    >
                      <v-row class="subtextlable"> Warehouse </v-row>
                      <v-row>
                        {{
                          PurchaseOrder.warehouses.name
                            ? PurchaseOrder.warehouses.name
                            : '----'
                        }}
                      </v-row>
                    </v-col>
                    <!-- <v-col
                          cols="12"
                          sm="12"
                          md="2"
                          lg="2"
                          class="textbold pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Customer </v-row>
                          <v-row>
                            
                          </v-row>
                        </v-col> -->
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="12"
          lg="12"
          xl="12"
          class="py-1 px-5"
        >
          <v-card height="100%" class="lighten-12">
            <v-card-title class="d-flex justify-space-between">
              Purchase order products
            </v-card-title>
            <v-container fluid class="container saledetailscard">
              <PurchaseOrderTemplate
                :data="selectedProductsItems"
                :purchaseOrder="PurchaseOrder"
                class="test1"
                id="qr-code"
                style="display: none"
              ></PurchaseOrderTemplate>
              <v-row>
                <v-col cols="12" class="pa-0">
                  <v-data-table
                    :headers="purchaseorderheaders"
                    :items="selectedProductsItems"
                    hide-default-footer
                    disable-pagination
                    dense
                  >
                    <!-- Category -->
                    <template v-slot:item.code="{ item }">
                      <div class="orderData">
                        {{ item.code ? item.code : '----' }}
                      </div>
                    </template>
                    <template v-slot:item.name="{ item }">
                      <div class="orderData">
                        {{ item.name ? item.name : '----' }}
                      </div>
                    </template>
                    <template v-slot:item.unit.name="{ item }">
                      <div class="orderData">
                        {{ item.unit.name ? item.unit.name : '----' }}
                      </div>
                    </template>
                    <template v-slot:item.quantity="{ item }">
                      <div class="orderData">
                        {{ item.quantity ? item.quantity : '----' }}
                      </div>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12" class="py-1 px-5">
          <v-card height="100%">
            <v-card-title>Note</v-card-title>

            <v-container fluid class="container saledetailscard">
              <v-row>
                <v-col cols="6" sm="6" md="12" lg="12"
                  ><v-chip class="pa-0" label>
                    {{ PurchaseOrder.remarks ? PurchaseOrder.remarks : '----' }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="12" class="py-1 px-5">
          <AuditLogs :Type="'purchase_orders'" />
        </v-col>
      </v-row>

      <!-- Purchase order bill -->
      <purchaseOrderbill
        :PurchaseOrderDetails="PurchaseOrder"
        :ProductData="selectedProductsItems"
        :Suppliers="Supplier"
        ref="CallingBill"
        @closePreview="closePreview"
        v-show="false"
        :visible="purchaseOrderBillVisible"
      />
    </v-container>
  </div>
</template>

<script>
import purchaseOrderbill from '@/components/shared/PurchaseOrderBill.vue';
import FileUpload from '@/components/base/FileUpload';
import jsPDF from 'jspdf';
import VueDocPreview from 'vue-doc-preview';
import 'jspdf-autotable';
import { PurchaseOrderViewModel } from '../../../models/View Models/PurchaseOrderViewModel';
export default {
  data: () => ({
    PurchaseOrder: [],
    heading: 'Sample PDF Generator',
    moreText: [
      'This is another few sentences of text to look at it.',
      'Just testing the paragraphs to see how they format.',
      'jsPDF likes arrays for sentences.',
      'Do paragraphs wrap properly?',
      'Yes, they do!',
      'What does it look like?',
      'Not bad at all.',
    ],

    selectedProductsItems: [],
    purchaseOrderBillVisible: false,
    purchaseorderheaders: [
      { text: 'Code', value: 'code', sortable: false },
      { text: 'Name', value: 'name', sortable: false },
      // { text: "Unit Code", value: "" ,sortable: false},
      { text: 'Unit', value: 'unit.name', sortable: false },
      { text: 'Qty', value: 'quantity', sortable: false, align: 'center' },
    ],
  }),
  methods: {
    closePreview() {
      this.purchaseOrderBillVisible = false;
    },
    GotoPrintDetails() {
      setTimeout(() => {
        this.purchaseOrderBillVisible = true;
      }, 100);
    },
    getPurchaseOrderStatusColor(status) {
      switch (status) {
        case 'Received':
          return 'green';
          break;
        case 'Pending':
          return 'orange';
          break;
        case 'Canceled':
          return 'red';
          break;
        default:
          break;
      }
    },
    print() {
      this.$htmlToPaper('qr-code');
    },
    getPurchaseOrder() {
      let Id = this.$route.params.id;
      this.$store
        .dispatch('purchaseOrder/GetPurchaseOder', Id)
        .then(async (res) => {
          this.PurchaseOrder = new PurchaseOrderViewModel(res.data);
          await this.getOrganization();
          this.selectedProductsItems = this.PurchaseOrder.products;
          this.Supplier = this.PurchaseOrder.supplier;
          this.selectedProducts = [];
          this.PurchaseOrder.products.forEach((product) => {
            const tempProduct = this.products.find(
              (item) => item.id === product.product_id,
            );
            tempProduct.quantity = product.quantity;
            this.selectedProducts.push(tempProduct);
          });

          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
    async getOrganization() {
      await this.$store
        .dispatch('sitesetting/OrganizationView', 1)
        .then((res) => {
          if (res && res.data) {
            this.PurchaseOrder.organization = res.data;
            console.clear();
          }
        })
        .catch((err) => {
          this.messages = err.data.title;
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getPurchaseOrder();
  },
  components: {
    FileUpload,
    VueDocPreview,
    purchaseOrderbill,
  },
  computed: {
    printQr() {
      return {
        id: 'qr-code',
        popTitle: this.PurchaseOrder.name,
      };
    },
  },
};
</script>

<style scoped>
.orderData {
  font-weight: bold;
}
.v-card__title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  word-break: break-all;
  padding: 0 !important;
  padding-left: 10px !important;
}
.subtextlable {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  line-height: 11px;
  /* identical to box height */

  text-align: left;

  color: #928686;
}
.reference_number {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.textbold {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 14px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.saledetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.statustext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 12px;
  /* identical to box height */

  text-align: center;

  color: #045894;
}
</style>
